import { render, staticRenderFns } from "./WtDisplayRichTextHTML.vue?vue&type=template&id=51b9d704&scoped=true&lang=pug&"
import script from "./WtDisplayRichTextHTML.vue?vue&type=script&lang=js&"
export * from "./WtDisplayRichTextHTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b9d704",
  null
  
)

export default component.exports